import {detectedRegex, enToRu, enToDe, enToKz, enToFr, enToEs} from "../locales/keyboard"

function invert(obj) {
    return Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [v, k])
    );
}

function composeMaps(mapA, mapB) {
    const result = {};
    for (const key in mapA) {
        const mid = mapA[key];
        result[key] = mapB[mid] || mid;
    }
    return result;
}
export const whitelist = [
    'abs', 'map', 'maf', 'ecu', 'esp', 'egr',
    'obd', 'obd2', 'can', 'dtc', 'vvt', 'tps',
    'rpm', 'bar', 'psi', 'vin', 'vtec'
];
const baseMaps = {
    en: null,
    es: enToEs,
    de: enToDe,
    ru: enToRu,
    kz: enToKz,
    fr: enToFr
};
const toEnMaps = {};
for (const lang in baseMaps) {
    if (lang !== "en") {
        toEnMaps[lang] = invert(baseMaps[lang]);
    }
}
const layoutLang = {};
const langs = Object.keys(baseMaps);
langs.forEach(fromLang => {
    layoutLang[fromLang] = {};

    langs.forEach(toLang => {
        if (fromLang === toLang) return;

        if (fromLang === "en") {
            layoutLang[fromLang][toLang] = baseMaps[toLang];
        } else if (toLang === "en") {
            layoutLang[fromLang][toLang] = toEnMaps[fromLang];
        } else {
            layoutLang[fromLang][toLang] =
                composeMaps(toEnMaps[fromLang], baseMaps[toLang]);
        }
    });
});
const detectLanguage = (word) => {
    word = word.toLowerCase();
    for (const lang in detectedRegex) {
        if (detectedRegex[lang].test(word)) {
            return lang; // возвращаем ключ: 'ru', 'en', 'de' или 'es'
        }
    }
    return 'unknown';
}

export function fixLayoutLang(text, target = 'en') {
    return text.split(' ').map(word => {
        const detected = detectLanguage(word);
        if (detected === target || detected === 'unknown') return word;
        return word.split('').map(char => {
            const low = char.toLowerCase();
            if (layoutLang[detected][target][low]) {
                const res = layoutLang[detected][target][low];
                return char === char.toUpperCase() ? res.toUpperCase() : res;
            }
            return char;
        }).join('');

    }).join(' ');


}
//console.log(layoutLang)
export function fixLayout(text, target) {


    return text.split(' ').map(word => {
        // Очищаем слово от знаков препинания для проверки в белом списке
        const cleanWord = word.toLowerCase();

        // Если в слове уже есть кириллица (для ru) или исп. символы, не трогаем
        const skipRegex = detectedRegex[target];

        if (whitelist.includes(cleanWord)) return word;
        if (skipRegex && skipRegex.test(word)) return word;

        const detected = detectLanguage(word);
        if (detected === 'unknown') return word;

        return word.split('').map(char => {
            const low = char.toLowerCase();
            if (layoutLang[detected][target][low]) {
                const res = layoutLang[detected][target][low];
                return char === char.toUpperCase() ? res.toUpperCase() : res;
            }
            return char;
        }).join('');

    }).join(' ');
}
